'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Link from 'next/link';
import { useState, useEffect, useCallback, useRef } from 'react';
import Modal from 'react-modal';
import SiteCover from '@/app/_components/SiteCover';
import logoGrayPrimary from '@/public/images/hive-logo-gray.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import { faChevronLeft, faXmark } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import { faChevronLeft as faChevronLeftLight, faChevronRight as faChevronRightLight } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import { faPlay } from '@awesome.me/kit-94e593bf23/icons/sharp/solid';
import { faPause } from '@awesome.me/kit-94e593bf23/icons/sharp/solid';
import '@/app/_styles/react-modal-product-carousel.css';
import '@/app/_styles/carousel_thumbs.css';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import AutoScroll from 'embla-carousel-auto-scroll';
import Fade from 'embla-carousel-fade';
import { useAutoplayProgress } from './EmbalAutoplayProgress';
import { Thumb } from "./CarouselThumb";
import VideoSlide from "./VideoSlide";
import { decodeEntities } from '@/app/_lib/services/ClientUtil';
const ProductCarouselModal = t0 => {
  const $ = _c(173);
  const {
    carouselModalOpen,
    setCarouselModalOpen,
    sub_product,
    slides,
    initialSlideIndex: t1,
    onPlayVideo
  } = t0;
  const initialSlideIndex = t1 === undefined ? 0 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  useEffect(_temp, t2);
  useState("swatches");
  let t3;
  if ($[1] !== setCarouselModalOpen) {
    t3 = () => {
      setCarouselModalOpen(false);
    };
    $[1] = setCarouselModalOpen;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const closeModal = t3;
  useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [canScrollPrevThumb, setCanScrollPrevThumb] = useState(false);
  const [canScrollNextThumb, setCanScrollNextThumb] = useState(false);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      x: 0,
      y: 0
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const [cursorPos, setCursorPos] = useState(t4);
  const [cursorVisible, setCursorVisible] = useState(false);
  const [cursorSide, setCursorSide] = useState("right");
  const imageContainerRef = useRef(null);
  const handleSlideChange = _temp2;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      loop: true,
      skipSnaps: false,
      dragFree: false,
      dragThreshold: 10,
      duration: 60,
      breakpoints: {
        "(max-width: 768px)": {
          duration: 30
        }
      },
      watchSlides: handleSlideChange
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const [emplaOptions] = useState(t5);
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      delay: 4000,
      playOnInit: false
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const [autoplayOptions] = useState(t6);
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      breakpoints: {
        "(max-width: 768px)": {
          active: false
        }
      }
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const [fadeOptions] = useState(t7);
  let t8;
  if ($[7] !== fadeOptions) {
    t8 = Fade(fadeOptions);
    $[7] = fadeOptions;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== autoplayOptions) {
    t9 = Autoplay(autoplayOptions);
    $[9] = autoplayOptions;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t8 || $[12] !== t9) {
    t10 = [t8, t9];
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const [mainViewportRef, emblaAPI] = useEmblaCarousel(emplaOptions, t10);
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      loop: false,
      containScroll: "keepSnaps",
      dragFree: true,
      align: "center",
      duration: 250
    };
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  const [emblaThumbOptions] = useState(t11);
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      playOnInit: false,
      speed: 3,
      startDelay: 0,
      direction: "forward",
      stopOnInteraction: true,
      stopOnMouseEnter: true
    };
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  const [autoScrollOptions, setAutoScrollOptions] = useState(t12);
  let t13;
  if ($[16] !== autoScrollOptions) {
    t13 = AutoScroll(autoScrollOptions);
    $[16] = autoScrollOptions;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t13) {
    t14 = [t13];
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  const [emblaThumbsRef, emblaThumbsAPI] = useEmblaCarousel(emblaThumbOptions, t14);
  let t15;
  if ($[20] !== emblaAPI || $[21] !== emblaThumbsAPI || $[22] !== onPlayVideo || $[23] !== slides) {
    t15 = index => {
      if (!emblaAPI || !emblaThumbsAPI) {
        return;
      } else {
        emblaAPI.scrollTo(index);
      }
      if (slides[index]?.type === "video" && onPlayVideo) {
        onPlayVideo(slides[index]);
      }
    };
    $[20] = emblaAPI;
    $[21] = emblaThumbsAPI;
    $[22] = onPlayVideo;
    $[23] = slides;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  const onThumbClick = t15;
  let t16;
  if ($[25] !== emblaThumbsAPI) {
    t16 = () => {
      if (!emblaThumbsAPI) {
        return;
      }
      const engine = emblaThumbsAPI.internalEngine();
      const currentPosition = engine.location.get();
      engine.animation.stop();
      engine.target.set(currentPosition);
      engine.location.set(currentPosition);
      engine.translate.to(currentPosition);
    };
    $[25] = emblaThumbsAPI;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  const onThumbLeave = t16;
  let t17;
  if ($[27] !== emblaAPI || $[28] !== emblaThumbsAPI) {
    t17 = () => {
      if (!emblaAPI || !emblaThumbsAPI) {
        return;
      }
      setSelectedIndex(emblaAPI.selectedScrollSnap());
      emblaThumbsAPI.scrollTo(emblaAPI.selectedScrollSnap());
    };
    $[27] = emblaAPI;
    $[28] = emblaThumbsAPI;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  const onSelect = t17;
  let t18;
  if ($[30] !== emblaThumbsAPI) {
    t18 = () => {
      if (!emblaThumbsAPI) {
        return;
      }
      setCanScrollPrevThumb(emblaThumbsAPI.canScrollPrev());
      setCanScrollNextThumb(emblaThumbsAPI.canScrollNext());
    };
    $[30] = emblaThumbsAPI;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  const updateThumbScrollButtons = t18;
  let t19;
  if ($[32] !== emblaAPI) {
    t19 = () => {
      if (!emblaAPI) {
        return;
      }
    };
    $[32] = emblaAPI;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  const reInitialize = t19;
  let t20;
  if ($[34] !== emblaAPI) {
    t20 = () => {
      if (!emblaAPI) {
        return;
      }
      emblaAPI.scrollPrev();
    };
    $[34] = emblaAPI;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  const scrollPrev = t20;
  let t21;
  if ($[36] !== emblaAPI) {
    t21 = () => {
      if (!emblaAPI) {
        return;
      }
      emblaAPI.scrollNext();
    };
    $[36] = emblaAPI;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  const scrollNext = t21;
  let t22;
  if ($[38] !== scrollNext || $[39] !== scrollPrev) {
    t22 = event => {
      if (event.key == "ArrowLeft") {
        scrollPrev();
      }
      if (event.key == "ArrowRight") {
        scrollNext();
      }
    };
    $[38] = scrollNext;
    $[39] = scrollPrev;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  const handleKeyDown = t22;
  let t23;
  let t24;
  if ($[41] !== emblaAPI || $[42] !== emblaThumbsAPI || $[43] !== onSelect || $[44] !== reInitialize || $[45] !== updateThumbScrollButtons) {
    t23 = () => {
      if (!emblaAPI || !emblaThumbsAPI) {
        return;
      }
      onSelect();
      updateThumbScrollButtons();
      emblaAPI.on("select", onSelect);
      emblaAPI.on("reInit", reInitialize);
      emblaThumbsAPI.on("select", updateThumbScrollButtons);
      emblaThumbsAPI.on("reInit", updateThumbScrollButtons);
      return () => {
        emblaThumbsAPI.off("select", updateThumbScrollButtons);
        emblaThumbsAPI.off("reInit", updateThumbScrollButtons);
      };
    };
    t24 = [emblaAPI, emblaThumbsAPI, onSelect, reInitialize, updateThumbScrollButtons];
    $[41] = emblaAPI;
    $[42] = emblaThumbsAPI;
    $[43] = onSelect;
    $[44] = reInitialize;
    $[45] = updateThumbScrollButtons;
    $[46] = t23;
    $[47] = t24;
  } else {
    t23 = $[46];
    t24 = $[47];
  }
  useEffect(t23, t24);
  let t25;
  let t26;
  if ($[48] !== carouselModalOpen || $[49] !== emblaAPI || $[50] !== handleKeyDown) {
    t25 = () => {
      if (!emblaAPI || !carouselModalOpen) {
        return;
      }
      window.addEventListener("keydown", handleKeyDown);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    };
    t26 = [emblaAPI, carouselModalOpen, handleKeyDown];
    $[48] = carouselModalOpen;
    $[49] = emblaAPI;
    $[50] = handleKeyDown;
    $[51] = t25;
    $[52] = t26;
  } else {
    t25 = $[51];
    t26 = $[52];
  }
  useEffect(t25, t26);
  let t27;
  let t28;
  if ($[53] !== carouselModalOpen || $[54] !== emblaAPI || $[55] !== initialSlideIndex) {
    t27 = () => {
      if (!emblaAPI || !carouselModalOpen) {
        return;
      }
      emblaAPI.scrollTo(initialSlideIndex);
    };
    t28 = [emblaAPI, carouselModalOpen, initialSlideIndex];
    $[53] = carouselModalOpen;
    $[54] = emblaAPI;
    $[55] = initialSlideIndex;
    $[56] = t27;
    $[57] = t28;
  } else {
    t27 = $[56];
    t28 = $[57];
  }
  useEffect(t27, t28);
  const [isPlaying, setIsPlaying] = useState(false);
  let t29;
  if ($[58] !== emblaAPI) {
    t29 = () => {
      const autoplay = emblaAPI?.plugins()?.autoplay;
      if (!emblaAPI || !autoplay) {
        return;
      }
      if (autoplay.isPlaying()) {
        autoplay.stop();
        setIsPlaying(false);
      } else {
        autoplay.play();
        setIsPlaying(true);
      }
    };
    $[58] = emblaAPI;
    $[59] = t29;
  } else {
    t29 = $[59];
  }
  const play = t29;
  let t30;
  if ($[60] !== autoScrollOptions || $[61] !== emblaThumbsAPI) {
    t30 = event_0 => {
      const autoScroll = emblaThumbsAPI?.plugins()?.autoScroll;
      if (!autoScroll) {
        return;
      }
      autoScroll.play();
      if (autoScrollOptions.direction != "backward") {
        setAutoScrollOptions(_temp3);
        autoScroll.play();
      }
    };
    $[60] = autoScrollOptions;
    $[61] = emblaThumbsAPI;
    $[62] = t30;
  } else {
    t30 = $[62];
  }
  const scrollLeft = t30;
  let t31;
  if ($[63] !== emblaThumbsAPI) {
    t31 = event_1 => {
      const autoScroll_0 = emblaThumbsAPI?.plugins()?.autoScroll;
      if (!autoScroll_0) {
        return;
      }
      autoScroll_0.stop();
    };
    $[63] = emblaThumbsAPI;
    $[64] = t31;
  } else {
    t31 = $[64];
  }
  const scrollLeftStop = t31;
  let t32;
  if ($[65] !== autoScrollOptions || $[66] !== emblaThumbsAPI) {
    t32 = event_2 => {
      const autoScroll_1 = emblaThumbsAPI?.plugins()?.autoScroll;
      if (!autoScroll_1) {
        return;
      }
      autoScroll_1.play();
      if (autoScrollOptions.direction != "forward") {
        setAutoScrollOptions(_temp4);
        autoScroll_1.play();
      }
    };
    $[65] = autoScrollOptions;
    $[66] = emblaThumbsAPI;
    $[67] = t32;
  } else {
    t32 = $[67];
  }
  const scrollRight = t32;
  let t33;
  if ($[68] !== emblaThumbsAPI) {
    t33 = event_3 => {
      const autoScroll_2 = emblaThumbsAPI?.plugins()?.autoScroll;
      if (!autoScroll_2) {
        return;
      }
      autoScroll_2.stop();
    };
    $[68] = emblaThumbsAPI;
    $[69] = t33;
  } else {
    t33 = $[69];
  }
  const scrollRightStop = t33;
  let t34;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = e => {
      if (!imageContainerRef.current) {
        return;
      }
      const rect = imageContainerRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left;
      setCursorPos({
        x: e.clientX,
        y: e.clientY
      });
      setCursorSide(x < rect.width / 2 ? "left" : "right");
    };
    $[70] = t34;
  } else {
    t34 = $[70];
  }
  const handleImageMouseMove = t34;
  let t35;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = () => {
      setCursorVisible(true);
    };
    $[71] = t35;
  } else {
    t35 = $[71];
  }
  const handleImageMouseEnter = t35;
  let t36;
  if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = () => {
      setCursorVisible(false);
    };
    $[72] = t36;
  } else {
    t36 = $[72];
  }
  const handleImageMouseLeave = t36;
  let t37;
  if ($[73] !== cursorSide || $[74] !== scrollNext || $[75] !== scrollPrev) {
    t37 = () => {
      if (cursorSide === "left") {
        scrollPrev();
      } else {
        scrollNext();
      }
    };
    $[73] = cursorSide;
    $[74] = scrollNext;
    $[75] = scrollPrev;
    $[76] = t37;
  } else {
    t37 = $[76];
  }
  const handleImageClick = t37;
  const length = slides.length;
  const progressNode = useRef(null);
  const {
    showAutoplayProgress
  } = useAutoplayProgress(emblaAPI, progressNode);
  let t38;
  if ($[77] !== sub_product.sub_product_name) {
    t38 = decodeEntities(sub_product.sub_product_name);
    $[77] = sub_product.sub_product_name;
    $[78] = t38;
  } else {
    t38 = $[78];
  }
  let t39;
  if ($[79] !== t38) {
    t39 = <div className="ml-6 text-3xl font-extralight capitalize">{t38}</div>;
    $[79] = t38;
    $[80] = t39;
  } else {
    t39 = $[80];
  }
  let t40;
  if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <Image src={logoGrayPrimary} alt="hive" className="w-[90px] h-[45px] mr-18" />;
    $[81] = t40;
  } else {
    t40 = $[81];
  }
  let t41;
  if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <FontAwesomeIcon icon={faXmark} className="text-4xl h-[18px]" />;
    $[82] = t41;
  } else {
    t41 = $[82];
  }
  let t42;
  if ($[83] !== closeModal) {
    t42 = <div className="flex items-end">{t40}<button onClick={closeModal} className="text-gray-400 hover:text-primary transition-colors mr-2" aria-label="Close">{t41}</button></div>;
    $[83] = closeModal;
    $[84] = t42;
  } else {
    t42 = $[84];
  }
  let t43;
  if ($[85] !== t39 || $[86] !== t42) {
    t43 = <div className="flex items-end justify-between w-full mb-5 flex-shrink-0">{t39}{t42}</div>;
    $[85] = t39;
    $[86] = t42;
    $[87] = t43;
  } else {
    t43 = $[87];
  }
  let t44;
  if ($[88] !== onPlayVideo || $[89] !== slides || $[90] !== sub_product.sub_product_name) {
    let t45;
    if ($[92] !== onPlayVideo || $[93] !== sub_product.sub_product_name) {
      t45 = (slide, index_0) => {
        if (slide.type === "video") {
          return <div key={`video-${slide.product_file_id}`} className="embla__slide flex items-center justify-center h-full relative pointer-events-auto"><VideoSlide video={slide} productName={decodeEntities(sub_product?.sub_product_name)} onPlay={() => onPlayVideo(slide)} /></div>;
        }
        const imagePath = slide.variant_id ? `${process.env.NEXT_PUBLIC_RESOURCE_URL}/${slide.file_name}` : `${process.env.NEXT_PUBLIC_RESOURCE_URL}/full/${slide.file_name}`;
        return <div key={index_0} className="embla__slide flex items-center justify-center h-full relative"><Image className="object-contain" src={imagePath} overrideSrc={imagePath} alt={slide.alt_attribute || decodeEntities(sub_product?.sub_product_name) || "Product image"} fill={true} sizes="calc(100vw - 88px)" quality={90} /></div>;
      };
      $[92] = onPlayVideo;
      $[93] = sub_product.sub_product_name;
      $[94] = t45;
    } else {
      t45 = $[94];
    }
    t44 = slides.map(t45);
    $[88] = onPlayVideo;
    $[89] = slides;
    $[90] = sub_product.sub_product_name;
    $[91] = t44;
  } else {
    t44 = $[91];
  }
  let t45;
  if ($[95] !== t44) {
    t45 = <div className="embla__container h-full items-center">{t44}</div>;
    $[95] = t44;
    $[96] = t45;
  } else {
    t45 = $[96];
  }
  let t46;
  if ($[97] !== mainViewportRef || $[98] !== t45) {
    t46 = <div className="embla overflow-hidden w-full h-full pointer-events-none" ref={mainViewportRef}>{t45}</div>;
    $[97] = mainViewportRef;
    $[98] = t45;
    $[99] = t46;
  } else {
    t46 = $[99];
  }
  let t47;
  if ($[100] !== cursorPos || $[101] !== cursorSide || $[102] !== cursorVisible) {
    t47 = cursorVisible && <div className="pointer-events-none fixed z-[1100] flex items-center justify-center w-12 h-12 rounded-full bg-white shadow-md transition-opacity duration-150" style={{
      left: cursorPos.x,
      top: cursorPos.y,
      transform: "translate(-50%, -50%)"
    }}><FontAwesomeIcon icon={cursorSide === "left" ? faChevronLeftLight : faChevronRightLight} className="text-xl text-dark" /></div>;
    $[100] = cursorPos;
    $[101] = cursorSide;
    $[102] = cursorVisible;
    $[103] = t47;
  } else {
    t47 = $[103];
  }
  let t48;
  if ($[104] !== handleImageClick || $[105] !== t46 || $[106] !== t47) {
    t48 = <div ref={imageContainerRef} className="flex-1 flex items-center justify-center relative overflow-hidden cursor-none" onMouseMove={handleImageMouseMove} onMouseEnter={handleImageMouseEnter} onMouseLeave={handleImageMouseLeave} onClick={handleImageClick}>{t46}{t47}</div>;
    $[104] = handleImageClick;
    $[105] = t46;
    $[106] = t47;
    $[107] = t48;
  } else {
    t48 = $[107];
  }
  let t49;
  if ($[108] !== canScrollNextThumb || $[109] !== canScrollPrevThumb || $[110] !== scrollLeft || $[111] !== scrollLeftStop) {
    t49 = (canScrollPrevThumb || canScrollNextThumb) && <button aria-label="Previous" onMouseEnter={() => scrollLeft()} onClick={() => scrollLeft()} onMouseLeave={() => scrollLeftStop()} className={`group pl-2 pr-4 shrink-0 transition-opacity duration-300 ${canScrollPrevThumb ? "opacity-100" : "opacity-30 pointer-events-none"}`}><FontAwesomeIcon icon={faChevronLeft} className="text-xl text-dark font-extralight group-hover:text-primary" /></button>;
    $[108] = canScrollNextThumb;
    $[109] = canScrollPrevThumb;
    $[110] = scrollLeft;
    $[111] = scrollLeftStop;
    $[112] = t49;
  } else {
    t49 = $[112];
  }
  let t50;
  if ($[113] !== onThumbClick || $[114] !== selectedIndex || $[115] !== slides || $[116] !== sub_product.sub_product_name) {
    let t51;
    if ($[118] !== onThumbClick || $[119] !== selectedIndex || $[120] !== sub_product.sub_product_name) {
      t51 = (slide_0, index_1) => <div key={slide_0.type === "video" ? `video-${slide_0.product_file_id}` : index_1} className="embla-thumbs__slide grow-0 shrink-0 basis-24 mr-3"><Thumb onClick={() => onThumbClick(index_1)} onMouseEnter={() => onThumbClick(index_1)} selected={index_1 === selectedIndex} slide={slide_0} productName={decodeEntities(sub_product?.sub_product_name)} /></div>;
      $[118] = onThumbClick;
      $[119] = selectedIndex;
      $[120] = sub_product.sub_product_name;
      $[121] = t51;
    } else {
      t51 = $[121];
    }
    t50 = slides.map(t51);
    $[113] = onThumbClick;
    $[114] = selectedIndex;
    $[115] = slides;
    $[116] = sub_product.sub_product_name;
    $[117] = t50;
  } else {
    t50 = $[117];
  }
  let t51;
  if ($[122] !== t50) {
    t51 = <div className="embla-thumbs__container h-16 justify-center">{t50}</div>;
    $[122] = t50;
    $[123] = t51;
  } else {
    t51 = $[123];
  }
  let t52;
  if ($[124] !== emblaThumbsRef || $[125] !== t51) {
    t52 = <div className="embla-thumbs__viewport overflow-hidden" ref={emblaThumbsRef}>{t51}</div>;
    $[124] = emblaThumbsRef;
    $[125] = t51;
    $[126] = t52;
  } else {
    t52 = $[126];
  }
  let t53;
  if ($[127] !== onThumbLeave || $[128] !== t52) {
    t53 = <div className="embla-thumbs flex-1 min-w-0 flex justify-center" onMouseLeave={onThumbLeave}>{t52}</div>;
    $[127] = onThumbLeave;
    $[128] = t52;
    $[129] = t53;
  } else {
    t53 = $[129];
  }
  let t54;
  if ($[130] !== canScrollNextThumb || $[131] !== canScrollPrevThumb || $[132] !== scrollRight || $[133] !== scrollRightStop) {
    t54 = (canScrollPrevThumb || canScrollNextThumb) && <button aria-label="Next" onMouseEnter={() => scrollRight()} onClick={() => scrollRight()} onMouseLeave={() => scrollRightStop()} className={`group pl-4 pr-2 shrink-0 transition-opacity duration-300 ${canScrollNextThumb ? "opacity-100" : "opacity-30 pointer-events-none"}`}><FontAwesomeIcon icon={faChevronRight} className="text-xl text-dark font-extralight group-hover:text-primary" /></button>;
    $[130] = canScrollNextThumb;
    $[131] = canScrollPrevThumb;
    $[132] = scrollRight;
    $[133] = scrollRightStop;
    $[134] = t54;
  } else {
    t54 = $[134];
  }
  let t55;
  if ($[135] !== t49 || $[136] !== t53 || $[137] !== t54) {
    t55 = <div className="flex items-center">{t49}{t53}{t54}</div>;
    $[135] = t49;
    $[136] = t53;
    $[137] = t54;
    $[138] = t55;
  } else {
    t55 = $[138];
  }
  let t56;
  if ($[139] !== length || $[140] !== selectedIndex) {
    t56 = length > 0 && <div className="text-2xs text-light-3 me-4">{selectedIndex + 1} / {length}</div>;
    $[139] = length;
    $[140] = selectedIndex;
    $[141] = t56;
  } else {
    t56 = $[141];
  }
  let t57;
  if ($[142] !== play) {
    t57 = () => play();
    $[142] = play;
    $[143] = t57;
  } else {
    t57 = $[143];
  }
  const t58 = isPlaying ? "Pause carousel" : "Play carousel";
  let t59;
  if ($[144] !== isPlaying) {
    t59 = isPlaying && <FontAwesomeIcon icon={faPause} className="text-xs text-[#c8c8c8] group-hover:text-primary" />;
    $[144] = isPlaying;
    $[145] = t59;
  } else {
    t59 = $[145];
  }
  let t60;
  if ($[146] !== isPlaying) {
    t60 = !isPlaying && <FontAwesomeIcon icon={faPlay} className="text-xs text-[#c8c8c8] group-hover:text-primary" />;
    $[146] = isPlaying;
    $[147] = t60;
  } else {
    t60 = $[147];
  }
  let t61;
  if ($[148] !== t57 || $[149] !== t58 || $[150] !== t59 || $[151] !== t60) {
    t61 = <button onClick={t57} className="group p-0 m-0 text-[0] pb-[.05rem]" aria-label={t58}>{t59}{t60}</button>;
    $[148] = t57;
    $[149] = t58;
    $[150] = t59;
    $[151] = t60;
    $[152] = t61;
  } else {
    t61 = $[152];
  }
  let t62;
  if ($[153] !== t56 || $[154] !== t61) {
    t62 = <div className="flex items-center justify-end lg:mr-4">{t56}{t61}</div>;
    $[153] = t56;
    $[154] = t61;
    $[155] = t62;
  } else {
    t62 = $[155];
  }
  let t63;
  if ($[156] !== showAutoplayProgress) {
    t63 = "flex items-center justify-end mt-2 lg:mr-4 embla__progress".concat(showAutoplayProgress ? "" : " embla__progress--hidden");
    $[156] = showAutoplayProgress;
    $[157] = t63;
  } else {
    t63 = $[157];
  }
  let t64;
  if ($[158] === Symbol.for("react.memo_cache_sentinel")) {
    t64 = <div className="embla__progress__bar" ref={progressNode} />;
    $[158] = t64;
  } else {
    t64 = $[158];
  }
  let t65;
  if ($[159] !== t63) {
    t65 = <div className={t63}>{t64}</div>;
    $[159] = t63;
    $[160] = t65;
  } else {
    t65 = $[160];
  }
  let t66;
  if ($[161] !== t55 || $[162] !== t62 || $[163] !== t65) {
    t66 = <div className="mt-3 flex-shrink-0">{t55}{t62}{t65}</div>;
    $[161] = t55;
    $[162] = t62;
    $[163] = t65;
    $[164] = t66;
  } else {
    t66 = $[164];
  }
  let t67;
  if ($[165] !== t43 || $[166] !== t48 || $[167] !== t66) {
    t67 = <div className="transition-all duration-100 bg-white flex flex-col h-full overflow-hidden">{t43}{t48}{t66}</div>;
    $[165] = t43;
    $[166] = t48;
    $[167] = t66;
    $[168] = t67;
  } else {
    t67 = $[168];
  }
  let t68;
  if ($[169] !== carouselModalOpen || $[170] !== closeModal || $[171] !== t67) {
    t68 = <><Modal overlayClassName="product-carousel fixed inset-0 outline-none bg-modal-overlay z-[1000]" className="fixed top-6 bottom-6 left-[var(--site-padding)] right-[var(--site-padding)] outline-none overscroll-contain bg-white p-5 rounded-md !shadow-lg" isOpen={carouselModalOpen} onRequestClose={closeModal} contentLabel="Carousel" closeTimeoutMS={700} bodyOpenClassName="ReactModal__Body--open" htmlOpenClassName="ReactModal__Html--open">{t67}</Modal></>;
    $[169] = carouselModalOpen;
    $[170] = closeModal;
    $[171] = t67;
    $[172] = t68;
  } else {
    t68 = $[172];
  }
  return t68;
};
export default ProductCarouselModal;
function _temp() {
  Modal.setAppElement("#hivenext");
}
function _temp2() {
  return false;
}
function _temp3(autoScrollOptions_0) {
  return {
    ...autoScrollOptions_0,
    direction: "backward",
    playOnInit: true
  };
}
function _temp4(autoScrollOptions_1) {
  return {
    ...autoScrollOptions_1,
    direction: "forward",
    playOnInit: true
  };
}